import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// @Mui
import { arEG, enUS } from "@mui/material/locale";
// config
import { allLangs, defaultLang } from "src/config";
//
import enLocales from "./EN/en";
import arLocales from "./AR/ar";

// ----------------------------------------------------------------------

const lng = localStorage.getItem("i18nextLng") || defaultLang.value;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      ar: { translations: arLocales },
    },
    lng,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
